module.exports = __webpack_public_path__ + "img/pdf-icon.020f0424.png";